import React from 'react';
import { useAppSelector } from '../hooks/storeHooks';
import CustomSyncLoader from './CustomSyncLoader';
import { getSyncingState } from '../utils/Helper/helper';

const StateSyncStatus = () => {
  const partnersState = useAppSelector((state) => state.partners);
  const presetState = useAppSelector((state) => state.presets);
  const moduleState = useAppSelector((state) => state.modules);
  const userState = useAppSelector((state) => state.users);
  const gitReportState = useAppSelector((state) => state.gitReport);
  const isSyncing =
    getSyncingState(partnersState) ||
    getSyncingState(presetState) ||
    getSyncingState(moduleState) ||
    getSyncingState(userState) ||
    getSyncingState(gitReportState);

  return (
    <div className="absolute top-28 right-5">
      <CustomSyncLoader isLoading={isSyncing} />
    </div>
  );
};

export default StateSyncStatus;
